// Webpack will do a static replacement of {{Stage}}
export const STAGE = '{{Stage}}' || 'development';